module.exports = __webpack_public_path__ + "img/facebook_icon.c3a60db0.svg";